import React, { useState, useEffect, useRef, useCallback } from 'react';
import './DetailComponents.css';

const AssignAssociateModal = ({ associates, assignedAssociateIds, onSave, onClose }) => {
  const [selectedAssociateId, setSelectedAssociateId] = useState('');
  const modalRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const handleSave = () => {
    const id = Number(selectedAssociateId);
    if (selectedAssociateId !== '' && !isNaN(id) && id >= 0) {
      onSave(id);
    }
  };

  const availableAssociates = associates.filter(associate => 
    !assignedAssociateIds.includes(associate.id)
  );

  return (
    <div className="modal-overlay">
      <div className="modal edit-modal" ref={modalRef}>
        <h3>Assign Travel Associate</h3>
        <div className="edit-modal-form">
          <div className="edit-modal-field">
            <label className="edit-modal-label">Select Associate:</label>
            {availableAssociates.length > 0 ? (
              <select
                className="edit-modal-input"
                value={selectedAssociateId}
                onChange={e => setSelectedAssociateId(e.target.value)}
              >
                <option value="">Select an associate</option>
                {availableAssociates.map(associate => (
                  <option key={associate.id} value={associate.id}>
                    {associate.name} ({associate.relationship})
                  </option>
                ))}
              </select>
            ) : (
              <p>No available travel associates</p>
            )}
          </div>
        </div>
        <div className="modal-actions">
          <button className="modal-action-button" onClick={onClose}>Cancel</button>
          <button className="modal-action-button" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default AssignAssociateModal;